import { useState } from 'react';
import { Link } from 'react-router-dom';
import More from '../../../../Components/Icons/More';
import { Modal, notification } from 'antd';
import axiosInstance from '../../../../Services/axiosCommon';
import { ExclamationCircleFilled } from "@ant-design/icons";
import SetReminderSubTask from './setSubTaskReminder';


const {confirm} = Modal

const ViewMoreSubTask = ({ data, getClients,id,projectId }) => {
  const [openReminder,setOpenReminder] = useState(false);
  const [api, contextHolder] = notification.useNotification();


  const handleDelete = async (id, removevalue) => {
    confirm({
      title: `Do you Want to delete ${removevalue}?`,
      centered: true,
      icon: <ExclamationCircleFilled />,
      content: `The ${removevalue} will be removed from the Task Plans`,
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        axiosInstance.delete(`/SubTask/${id}`).then((response) => {
            if (response.data?.status == true) {
              getClients(projectId);
              api.success({
                message: `Subtask  Deleted successfully`,
                // description:'',
                placement: "bottomRight",
              });
            } else {
              api.error({
                message: `Subtask Deleted failed`,
                description: response?.data?.msg || "Network error",
                placement: "bottomRight",
              });
            }
          })
          .catch((error) => {
            api.error({
              message: `Subtask  Deleted failed`,
              description: error?.response?.data?.msg || "Sever error (or) Network error",
              placement: "bottomRight",
            });
          });
      },
      onCancel() {},
    });
  };

  return (
    <>
      <div className='text-[#344767]  relative dropdown inline-block z-50'>
        {contextHolder}
        <div className=' cursor-pointer underline-offset-8 text-xs mx-auto font-semibold flex items-center'>
          <span className='pt-1'>
            <More/>
          </span>
        </div>
        <ul className='dropdown-menuOne bg-red-400  text-[#344767] text-left  rounded-lg absolute -left-[100px] -top-4 overflow-hidden hidden  z-50 shadow-lg'>
        <li className=' w-[100px] bg-black block m-0'>

              <Link 
              className='bg-white text-black hover:text-black hover:bg-gray-100 py-2 px-2 z-10 block whitespace-no-wrap text-xs font-medium' 
              to={`/tasks/subtask/view/${id}`} state={{projectId:projectId}}>View</Link>
              
       
          </li>
          <li className=' w-[100px] bg-black block m-0'>

              <Link 
               className='bg-white text-black hover:text-black hover:bg-gray-100 py-2 px-2 z-10 block whitespace-no-wrap text-xs font-medium' 
               to={`/tasks/subtask/edit/${id}`} state={{data:id,projectId:projectId}}>
               Edit
              </Link>
           
          </li>
          <li className=' w-[100px] bg-black block m-0'>
            <span
              className='bg-white hover:bg-gray-100 py-2 px-2 z-10 block whitespace-no-wrap text-xs font-medium'
              onClick={() => setOpenReminder(true)}
            >
              <Link className=' text-black hover:text-black' to={`#`}>Set Reminder</Link>
            </span>
          </li>
          <li className=''>
            <a
              className='bg-white text-black hover:text-black hover:bg-gray-100 py-2 px-2 block whitespace-no-wrap text-xs font-medium'
              to='#'
              onClick={() => {
                handleDelete(id,data?.subTaskName);
              }}
            >
              Delete
            </a>
          </li>
        </ul>
      </div>
      <SetReminderSubTask firstProject={projectId} subdata={data} open={openReminder} onCancel={() => { setOpenReminder(false) }} getData={getClients} />
    </>
  );
};

export default ViewMoreSubTask;
